export default __webpack_public_path__ + "static/media/property_751.da43fdd3.png";